import {
  AutoComplete,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  message,
} from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  SearchOutlined,
  LoadingOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import "./styles/supercodes.css";
import "./styles/editAndCreatePartner.css";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import config from "../../../config";
import SuperCodesTable from "./superCodesTable";

const base_url = config.base_url;
const SuperCodes = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const success = (type, message) => {
    messageApi.open({
      type: type,
      content: message,
    });
  };
  const [coupon, setCoupon] = useState("money");
  const [couponExpirationDate, setCouponExpirationDate] = useState(1);
  const [couponNumbers, setCouponNumbers] = useState("oneCoupon");
  const [checkCoupon, setCheckCoupon] = useState(false);
  const [couponAvailable, setCouponAvailable] = useState(true);
  const [loadCreateCoupon, setLoadCreateCoupon] = useState(false);
  const [showSuccessfullCouponCreated, setShowSuccessfullCouponCreated] =
    useState(false);
  const [checkMultipeCoupon, setCheckMultipeCoupon] = useState(false);
  const [associateCode, setAssociateCode] = useState(false);
  const [associatedPartnerId, setAssociatedPartnerId] = useState(undefined);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [parnterOptionsLoading, setParnterOptionsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [form] = Form.useForm();
  const recurrentValue = Form.useWatch("recurrent", form);
  const promotionTypeValue = Form.useWatch("promotion_type", form);
  const [promotionOptions, setPromotionOptions] = useState([]);
  const [showRadioButton, setShowRadioButton] = useState(true);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [specificPlansOptions, setSpecificPlansOptions] = useState([
    {
      label: "All Plans",
      value: "all",
    },
  ]);
  const [selectedPlans, setSelectedPlans] = useState([]);
  function generateRandomString(length = 12) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }
  const formateSuperCodeTableData = (arr) => {
    const transformedCoupons = arr.map((data, i) => {
      let description;
      let isTimeReward = false;
      if (data.customer_reward_amount) {
        description = `Fixed price $${data.customer_reward_amount}`;
      } else if (data.customer_reward_percentage) {
        description = `Discount ${data.customer_reward_percentage}%`;
      } else if (data.customer_reward_time) {
        description = `${data.customer_reward_time} months free`;
      } else if (
        !data.customer_reward_time &&
        !data.customer_reward_percentage &&
        !data.customer_reward_amount
      ) {
        description = `Time Reward`;
        isTimeReward = true;
      }
      return {
        ...data,
        date: dayjs(data.created).format("YYYY-MM-DD"),
        expanded: false,
        description,
        formattedRecurrent: data.recurrent ? "permanent" : "one time",
        isTimeReward,
      };
    });
    const grouped = {};

    transformedCoupons.forEach((coupon) => {
      // Split the coupon_family by '-'
      const family = coupon.coupon_family;

      // If the family is not already in the grouped object, add it
      if (!grouped[family]) {
        grouped[family] = {
          coupon_family: family,
          codes: [],
        };
      }

      // Add the full code to the codes array in the grouped object
      grouped[family].codes.push(coupon);
    });

    // Convert the grouped object back to an array
    const result = Object.values(grouped);

    const newRes = result
      .sort((a, b) => {
        return b.codes[0].created - a.codes[0].created;
      })
      .map((code, i) => {
        const totalUsedBy = [];
        let totalUsage = 0;
        let codeNames = [];
        code.codes.forEach((singleCode) => {
          singleCode.usage.forEach((x) => {
            totalUsedBy.push(x);
          });

          codeNames.push(singleCode.code);
        });
        // code.codes.usage.forEach((x) => {
        // });

        code.codes.forEach((x) => {
          totalUsage = +totalUsage + +x.max_usage;
        });
        return {
          ...code,
          index: result.length - i,
          date: code.codes[0].date,
          created_by_full_name: code.codes[0].created_by_full_name,
          description: code.codes[0].description,
          recurrent: code.codes[0].recurrent,
          formattedRecurrent: code.codes[0].formattedRecurrent,
          created_for: code.codes[0].created_for,
          status: code.codes[0].status,
          lifetime: code.codes[0].lifetime,
          isTimeReward: code.codes[0].isTimeReward,
          expiration_date: code.codes[0].expiration_date,
          subscription_end: code.codes[0].subscription_end,
          totalUsage,
          totalUsedBy,
          codeNames,
        };
      });

    return newRes;
    // OLD CODE IN CASE WE DECIDED TO REVERT BACK TO SINGLE ROW FOR EACH COUPON AND NOT GROUP IT BY FAMILY
    // arr
    //   .sort((a, b) => {
    //     return b.created - a.created;
    //   })
    //   .map((data, i) => {
    //     let description;
    //     let isTimeReward = false;
    //     if (data.customer_reward_amount) {
    //       description = `Fixed price $${data.customer_reward_amount}`;
    //     } else if (data.customer_reward_percentage) {
    //       description = `Discount ${data.customer_reward_percentage}%`;
    //     } else if (data.customer_reward_time) {
    //       description = `${data.customer_reward_time} months free`;
    //     } else if (
    //       !data.customer_reward_time &&
    //       !data.customer_reward_percentage &&
    //       !data.customer_reward_amount
    //     ) {
    //       description = `Time Reward`;
    //       isTimeReward = true;
    //     }
    //     return {
    //       ...data,
    //       date: dayjs(data.created).format("YYYY-MM-DD"),
    //       index: arr.length - i,
    //       expanded: false,
    //       description,
    //       formattedRecurrent: data.recurrent ? "permanent" : "one time",
    //       isTimeReward,
    //     };
    //   });
  };

  const settingDefaultFields = () => {
    form.setFieldsValue({
      single_coupon_status: "active",
      multipe_coupon_status: "active",
      coupon_expiration_date: 1,
      coupon_numbers: "oneCoupon",
      promotion_type: "money",
      recurrent: false,
      single_coupon_string: generateRandomString(),
      multipe_coupon_string: generateRandomString(),
      applies_to: "all",
    });
    setAssociateCode(false);
    setCouponExpirationDate(1);
    setCouponNumbers("oneCoupon");
    setCoupon("money");
  };
  useEffect(() => {
    settingDefaultFields();
    fetch(`${base_url}admin/supercodes/data/options`, {
      method: "POST",
      mode: "cors",
      titles: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200)
          throw new Error("Unable to load promotion options");
        else return res.json();
      })
      .then((data) => {
        setPromotionOptions(data);
      })
      .catch((err) => {
        console.log(err);
      });
    fetch(`${base_url}admin/supercodes/data/applies_to`, {
      method: "POST",
      mode: "cors",
      titles: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200)
          throw new Error("Unable to load promotion options");
        else return res.json();
      })
      .then((data) => {
        const formattedPlansArray = [...specificPlansOptions];
        setLoadingPlans(false);
        data.forEach((plan) => {
          formattedPlansArray.push({
            value: plan.id,
            label: plan.name,
          });
        });
        setSpecificPlansOptions(formattedPlansArray);
      })
      .catch((err) => {
        console.log(err);
        setLoadingPlans(false);
      });
  }, []);

  useEffect(() => {
    setParnterOptionsLoading(true);
    fetch(`${base_url}admin/partners/data`, {
      method: "POST",
      mode: "cors",
      body: ``,
      titles: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        const removeDuplicates = (arr) => {
          const valueCount = {};
          // Count occurrences of each value
          arr.forEach((item) => {
            if (valueCount[item.email_address]) {
              valueCount[item.email_address] += 1;
            } else {
              valueCount[item.email_address] = 1;
            }
          });

          // Filter out duplicates
          return arr.filter((item) => valueCount[item.email_address] === 1);
        };
        let formattedData = [];
        res.data.forEach((data) => {
          if (data.deleted === true) {
            return;
          }
          formattedData.push({
            ...data,
            value: data.email_address,
            label: `${data.name} (${data.email_address})`,
          });
        });
        formattedData = removeDuplicates(formattedData);
        // console.log(formattedData);
        setPartnersOptions(formattedData);
        setParnterOptionsLoading(false);
      });
    setTableLoading(true);
    fetch(`${base_url}admin/supercodes/data`, {
      method: "POST",
      mode: "cors",
      body: ``,
      titles: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        setTableData(formateSuperCodeTableData(res));
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);
      });
  }, []);
  const handleCreateCoupon = async (values) => {
    setLoadCreateCoupon(true);
    const created_for = values.created_for;
    let recurrent = values.recurrent;
    let applies_to = selectedPlans;
    let code_family;
    let total;
    let partner_id = undefined;
    let expiration_date = undefined;
    let status;
    let unique = true;
    let customer_reward_amount;
    let customer_reward_percentage;

    // let customer_reward_time;
    let plan_name = values?.plan_name;
    if (couponNumbers === "oneCoupon") {
      code_family = values.single_coupon_string;
      total = 1;
      status = values.single_coupon_status;
    } else if (couponNumbers === "multipeCoupon") {
      code_family = values.multipe_coupon_string;
      total = +values.multipe_coupon_number;
      status = values.multipe_coupon_status;
      unique = values.createSeperateCoupons;
    }
    if (associateCode) {
      partner_id = associatedPartnerId;
    }
    if (values.coupon_expiration_date === 2) {
      expiration_date = dayjs(values.expiration_date_for_copoun).valueOf();
    }
    if (values.promotion_type === "money") {
      customer_reward_amount = +values.coupon_amount;
    } else if (values.promotion_type === "percentage") {
      customer_reward_percentage = +values.coupon_amount;
    }
    // else if (values.promotion_type === "time") {
    //   customer_reward_time = +values.coupon_amount;
    // }

    await fetch(base_url + "admin/partners/validate/coupon", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `coupon=${code_family}`,
    })
      .then((res) => res.json())
      .then(async (data) => {
        console.log(data);
        setCouponAvailable(data.exist);
        if (couponNumbers === "oneCoupon") {
          setCheckCoupon(true);
        } else if (couponNumbers === "multipeCoupon") {
          setCheckMultipeCoupon(true);
        }
        if (data.exist === true) {
          setLoadCreateCoupon(false);
          return;
        }

        let bodyString = `code_family=${code_family}&created_for=${created_for}&total=${total}&recurrent=${recurrent}&status=${status}&unique=${unique}&plan_name=${plan_name}&applies_to=${applies_to}`;
        let body = {
          code_family,
          created_for,
          total,
          recurrent: `${recurrent}`,
          status,
          unique: `${unique}`,
          plan_name,
          applies_to,
        };

        if (expiration_date) {
          bodyString = bodyString + `&expiration_date=${expiration_date}`;
          body.expiration_date = expiration_date;
        }
        if (partner_id) {
          bodyString = bodyString + `&partner_id=${partner_id}`;
          body.partner_id = partner_id;
        }
        if (values.promotion_type === "money") {
          bodyString =
            bodyString + `&customer_reward_amount=${customer_reward_amount}`;
          body.customer_reward_amount = customer_reward_amount;
        } else if (values.promotion_type === "percentage") {
          bodyString =
            bodyString +
            `&customer_reward_percentage=${customer_reward_percentage}`;
          body.customer_reward_percentage = customer_reward_percentage;
        } else if (values.promotion_type === "time" && recurrent === true) {
          bodyString = bodyString + `&lifetime=${true}`;
          body.lifetime = true;
        }

        await fetch(base_url + "admin/supercodes/create", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-Type": "application/json",
            credentials: "include",
          },
          credentials: "include",
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((res) => {
            formateSuperCodeTableData(res.new_data);
            setTableData(formateSuperCodeTableData(res.new_data));
            console.log(res);
            setLoadCreateCoupon(false);
            form.resetFields();
            settingDefaultFields();
            setShowSuccessfullCouponCreated(true);
            setTimeout(() => {
              setShowSuccessfullCouponCreated(false);
              setCouponAvailable(false);
              setCheckCoupon(false);
              setCheckMultipeCoupon(false);
            }, 3000);
          });
      })
      .catch((err) => {
        success("error", "Coupon creation failed");
        setLoadCreateCoupon(false);
        setCouponAvailable(false);
        setCheckMultipeCoupon(false);
        setCheckCoupon(false);
      });
  };
  const oneCouponDivStyle = {
    marginBottom: "10px",
    fontWeight: "500",
  };
  const multipeCouponDivStyle = {
    marginBottom: "300px",
    fontWeight: "500",
  };

  if (couponNumbers === "oneCoupon") {
    oneCouponDivStyle.marginBottom = "150px";
    multipeCouponDivStyle.marginBottom = "70px";
  }
  if (checkCoupon && couponNumbers === "oneCoupon") {
    oneCouponDivStyle.marginBottom = "155px";
  }
  const singleCouponString = Form.useWatch("single_coupon_string", form);
  const multipeCouponString = Form.useWatch("multipe_coupon_string", form);
  return (
    <div>
      {contextHolder}
      <div className="firstContainer">
        <Form form={form} onFinish={handleCreateCoupon}>
          <div className="couponRow">
            <div
              className="couponRow_firstRow"
              style={{
                width: "100%",
                alignItems: "center",
                gap: "100px",
                marginBottom: "25px",
              }}
            >
              <Form.Item
                style={{
                  width: "265px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"created_for"}
                label="Created for"
                required
                rules={[
                  {
                    required: true,
                    message: "Created for cannot be empty ",
                  },
                ]}
              >
                <Input className="formInput" />
              </Form.Item>
              <div
                style={{
                  width: "300px",
                  textAlign: "left",
                }}
              >
                <Checkbox
                  defaultChecked={false}
                  onChange={(e) => {
                    setAssociateCode(e.target.checked);
                    if (!e.target.checked) {
                      form.resetFields(["partners_name"]);
                    }
                  }}
                  checked={associateCode}
                >
                  Associate super code with partner (when partner’s status
                  changed to inactive, all his super codes are inactive)
                </Checkbox>
              </div>

              <Form.Item
                style={{
                  width: "265px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"partners_name"}
                label="Partner's name"
                required={associateCode}
                rules={[
                  {
                    required: associateCode ? true : false,
                    message: "Please select a partner",
                  },
                ]}
              >
                <AutoComplete
                  style={{
                    width: "350px",
                    height: "46px",
                  }}
                  options={partnersOptions}
                  disabled={!associateCode}
                  filterOption={(inputValue, option) =>
                    option.label
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  onSelect={(value, option) => {
                    setAssociatedPartnerId(option.user_id);
                  }}
                >
                  {parnterOptionsLoading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        gap: "10px",
                      }}
                    >
                      <span>Loading partners data</span>
                      <LoadingOutlined
                        style={{
                          color: "black",
                        }}
                      />
                    </div>
                  ) : (
                    <Input
                      disabled={!associateCode}
                      placeholder="Search for partner by Name or Email"
                      className="formInput"
                      addonAfter={<SearchOutlined />}
                    />
                  )}
                </AutoComplete>
              </Form.Item>
            </div>
            <Form.Item
              style={{
                width: "265px",
              }}
              className="formLabel formLabelSuperCodes"
              labelCol={{ span: 24 }}
              name={"applies_to"}
              label="Is it for a specific plan?"
              required
              rules={[
                {
                  required: true,
                  message: "Specific plan cannot be empty ",
                },
              ]}
            >
              <Select
                disabled={loadingPlans}
                loading={loadingPlans}
                mode="multiple"
                style={{
                  width: "100%",
                }}
                placeholder="Please select"
                onChange={(e) => {
                  const removeAllPlanValue = e.filter((plan) => plan !== "all");
                  setSelectedPlans(removeAllPlanValue);
                }}
                options={specificPlansOptions}
              />
            </Form.Item>
            <div
              className="couponRow_firstRow"
              style={{
                width: "100%",
                marginBottom: "25px",
              }}
            >
              <Form.Item
                style={{
                  width: "265px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"promotion_type"}
                label="Promotion Type"
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{
                    height: "46px",
                    textAlign: "left",
                  }}
                  onChange={(e) => {
                    setCoupon(e);
                    form.setFieldsValue({
                      coupon_amount: undefined,
                    });
                  }}
                >
                  <Select.Option value="money">Fixed price</Select.Option>
                  <Select.Option value="percentage">
                    Discount - percentage
                  </Select.Option>
                  <Select.Option value="time">
                    Free Subscription plan
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"coupon_amount"}
                label="Amount per user"
                required={promotionTypeValue === "time" ? false : true}
                style={{
                  width: "135px",
                }}
                disabled={promotionTypeValue === "time" ? true : false}
                rules={[
                  {
                    required: promotionTypeValue === "time" ? false : true,
                    message: "Enter a valid value",
                  },
                ]}
              >
                {coupon === "money" && (
                  <InputNumber
                    controls={false}
                    addonBefore="$"
                    className="formInput"
                  />
                )}
                {coupon === "percentage" && (
                  <InputNumber
                    controls={false}
                    addonBefore="%"
                    className="formInput"
                  />
                )}
                {coupon === "time" && <Input className="formInput" />}
              </Form.Item>
              <Form.Item
                style={{
                  width: "265px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"recurrent"}
                label="Permanent Promotion (reoccurring)"
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{
                    height: "46px",
                    textAlign: "left",
                    width: "190px",
                    display: "flex",
                  }}
                  onChange={(e) => {
                    if (promotionTypeValue === "time" && e === true) {
                      form.setFieldsValue({
                        coupon_amount: undefined,
                      });
                    }
                  }}
                >
                  <Select.Option value={false}>
                    One time promotion
                  </Select.Option>
                  <Select.Option value={true}>Permanent</Select.Option>
                </Select>
              </Form.Item>
              {/* We need to set a new form for selecting the name of the plan for the users who use the supercode */}
              <Form.Item
                style={{
                  width: "265px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"plan_name"}
                label="Plan Name"
                required
                rules={[
                  {
                    required: true,
                    message: "Plan Name cannot be empty",
                  },
                ]}
              >
                <Select
                  style={{
                    height: "46px",
                    textAlign: "left",
                    width: "190px",
                    display: "flex",
                  }}
                  onChange={(e) => {
                    const plan_id = e;
                    const promotion = promotionOptions.filter(
                      (promotion) => promotion.id === plan_id
                    )[0];
                    if (promotion?.years) {
                      form.setFieldsValue({
                        expiration_date_for_copoun: dayjs(
                          Date.now() +
                            promotion?.years * 365 * 24 * 60 * 60 * 1000
                        ),
                        coupon_expiration_date: 2,
                      });
                      setCouponExpirationDate(2);
                      setShowRadioButton(false);
                    } else {
                      form.setFieldsValue({
                        expiration_date_for_copoun: undefined,
                        coupon_expiration_date: 1,
                      });
                      setCouponExpirationDate(1);
                      setShowRadioButton(true);
                    }
                  }}
                >
                  {promotionOptions?.map((option) => {
                    return (
                      <Select.Option key={option?.id} value={option?.id}>
                        {option?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                style={{
                  width: "210px",
                }}
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"coupon_expiration_date"}
                label={
                  Form.useWatch("promotion_type", form) === "time"
                    ? "free subscription will end at"
                    : "Coupon expiration date"
                }
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  value={couponExpirationDate}
                  disabled={!showRadioButton}
                  onChange={(e) => {
                    setCouponExpirationDate(e.target.value);
                    e.target.value === 1 &&
                      form.setFieldsValue({
                        expiration_date_for_copoun: undefined,
                      });
                    e.target.value === 2 &&
                      form.setFieldsValue({
                        expiration_date_for_copoun: dayjs().add(2, "month"),
                      });
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Space
                    direction="vertical"
                    style={{
                      marginLeft: "25px",
                    }}
                  >
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={1}
                    >
                      {Form.useWatch("promotion_type", form) === "time"
                        ? "Unlimited"
                        : "No expiration date"}
                    </Radio>
                    <Radio
                      style={{
                        width: "200px",
                      }}
                      value={2}
                    >
                      {Form.useWatch("promotion_type", form) === "time"
                        ? "Set a specific date"
                        : "Set expiration date:"}
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              {couponExpirationDate === 2 ? (
                <Form.Item
                  style={{
                    transform: "translate(-50px,60px)",
                    width: "206px",
                    height: "46px",
                    marginLeft: "25px",
                  }}
                  // className="formLabel formLabelSuperCodes"
                  // labelCol={{ span: 24 }}
                  // name={"coupon_expiration_date"}
                  // label="Coupon expiration date"
                  name={"expiration_date_for_copoun"}
                >
                  <DatePicker
                    allowClear={false}
                    onChange={(date, dateString) => {}}
                    style={{
                      // transform: "translate(-50px,55px)",
                      width: "206px",
                      height: "46px",
                    }}
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    disabledDate={(current) => {
                      let customDate = dayjs().format("YYYY-MM-DD");
                      return (
                        current && current < dayjs(customDate, "YYYY-MM-DD")
                      );
                    }}
                  />
                </Form.Item>
              ) : (
                <div
                  style={{
                    transform: "translateY(55px)",
                    width: "25%",
                    height: "46px",
                  }}
                ></div>
              )}
            </div>
            <div
              className="couponRow_SecondRow"
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Form.Item
                className="formLabel formLabelSuperCodes"
                labelCol={{ span: 24 }}
                name={"coupon_numbers"}
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  value={couponNumbers}
                  onChange={(e) => {
                    setCouponNumbers(e.target.value);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Radio style={oneCouponDivStyle} value={"oneCoupon"}>
                      One Coupon Code
                    </Radio>
                    <Radio
                      style={multipeCouponDivStyle}
                      value={"multipeCoupon"}
                    >
                      Multipe Coupon Code
                    </Radio>
                  </div>
                </Radio.Group>
              </Form.Item>
              {couponNumbers === "oneCoupon" && (
                <>
                  <div
                    className="oneCouponContentWrapper"
                    style={{
                      flexDirection: "column",
                      gap: 0,
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <Form.Item
                        style={{
                          width: "380px",
                        }}
                        className="formLabel formLabelSuperCodes"
                        labelCol={{ span: 24 }}
                        name={"single_coupon_string"}
                        label={
                          <p>
                            Add One Coupon Code
                            <span
                              style={{
                                fontSize: "13px",
                                fontWeight: "300",
                              }}
                            >
                              &nbsp;(This Coupon can be used once only)
                            </span>
                          </p>
                        }
                        required
                        rules={[
                          {
                            required: true,
                            message: "Enter a valid string",
                          },
                        ]}
                      >
                        <Input
                          onChange={(e) => {
                            setCheckCoupon(false);
                          }}
                          style={{
                            width: "254px",
                          }}
                          className="formInput"
                        />
                      </Form.Item>{" "}
                      <Form.Item
                        style={{
                          width: "380px",
                        }}
                        className="formLabel formLabelSuperCodes"
                        labelCol={{ span: 24 }}
                        name={"single_coupon_status"}
                        label="Coupon Status"
                        required
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Select
                          style={{
                            width: "113px",
                            height: "41px",
                            textAlign: "left",
                            display: "flex",
                          }}
                        >
                          <Select.Option value="active">Active</Select.Option>
                          <Select.Option value="inactive">
                            Inactive
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                    {couponAvailable && checkCoupon && (
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                        }}
                      >
                        <CloseCircleFilled style={{ color: "red" }} />
                        <span>Not Available,Try another name</span>
                      </div>
                    )}
                    {!couponAvailable && checkCoupon && (
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                        }}
                      >
                        <CheckCircleFilled
                          style={{ color: "rgba(65, 159, 35, 1)" }}
                        />
                        <span>Available</span>
                      </div>
                    )}
                    <span
                      style={
                        checkCoupon
                          ? {
                              marginTop: "5px",
                              fontWeight: "500",
                            }
                          : {
                              marginTop: "15px",
                              fontWeight: "500",
                            }
                      }
                    >
                      Super-Code URL:{" "}
                      <span
                        style={{
                          color: "rgba(0, 145, 234, 1)",
                          textDecoration: "underline",
                          fontWeight: "400",
                          fontSize: "15px",
                        }}
                      >
                        {window.location.origin}/register/?referral=
                        {singleCouponString}
                      </span>{" "}
                      <CopyOutlined
                        data-openpopup={"no"}
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            `${window.location.origin}/register/?referral=${singleCouponString}`
                          );
                          success("Super Code Copied");
                        }}
                        style={{
                          color: "rgb(0, 145, 234)",
                          cursor: "pointer",
                          transform: "scale(1.1)",
                          marginLeft: "10px",
                        }}
                      />
                    </span>
                    <div
                      style={{
                        display: "flex",
                        position: "absolute",
                        top: "180px ",
                        alignItems: "center",
                        gap: "10px",
                        left: "-15px",
                      }}
                    >
                      <Button
                        loading={loadCreateCoupon}
                        disabled={loadCreateCoupon}
                        onClick={(e) => {
                          form.submit();
                        }}
                        className="createCouponsButton"
                      >
                        Create Coupons
                      </Button>
                      {showSuccessfullCouponCreated && (
                        <div className="couponSuccessMessage">
                          <CheckCircleFilled
                            style={{
                              color: "rgba(65, 159, 35, 1)",
                            }}
                          />
                          <p>Coupon successfuly created</p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {couponNumbers === "multipeCoupon" && (
                <div
                  style={{
                    position: "absolute",
                    transform: "translateY(65px)",
                  }}
                >
                  <div
                    className="multipeCouponContentWrapper"
                    style={{
                      width: "100%",
                      gap: "5px",
                    }}
                  >
                    <Form.Item
                      className="formLabel formLabelSuperCodes"
                      labelCol={{ span: 24 }}
                      name={"multipe_coupon_number"}
                      label={
                        <p
                          style={{
                            fontWeight: "500",
                          }}
                        >
                          How many coupons
                        </p>
                      }
                      required
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid number",
                        },
                      ]}
                      style={{
                        width: "160px",
                      }}
                    >
                      <Input
                        style={{
                          width: "140px",
                        }}
                        className="formInput"
                      />
                    </Form.Item>
                    <Form.Item
                      className="formLabel formLabelSuperCodes"
                      labelCol={{ span: 24 }}
                      name={"createSeperateCoupons"}
                      label={
                        <p
                          style={{
                            fontWeight: "500",
                          }}
                        >
                          Create separate coupons
                        </p>
                      }
                      required
                      rules={[
                        {
                          required: true,
                          message: "Chose a valid value",
                        },
                      ]}
                      style={{
                        width: "190px",
                      }}
                    >
                      <Select
                        style={{
                          width: "140px",
                          height: "41px",
                          textAlign: "left",
                          display: "flex",
                        }}
                        defaultValue={"Choose"}
                        onChange={(e) => {}}
                      >
                        <Select.Option value={false}>Yes</Select.Option>
                        <Select.Option value={true}>No</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      className="formLabel formLabelSuperCodes"
                      labelCol={{ span: 24 }}
                      name={"multipe_coupon_status"}
                      label="Coupon Status"
                      required
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid string",
                        },
                      ]}
                    >
                      <Select
                        style={{
                          width: "113px",
                          height: "41px",
                          textAlign: "left",
                          display: "flex",
                        }}
                        onChange={(e) => {}}
                      >
                        <Select.Option value="active">Active</Select.Option>
                        <Select.Option value="inactive">Inactive</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <Form.Item
                    className="formLabel formLabelSuperCodes"
                    labelCol={{ span: 24 }}
                    name={"multipe_coupon_string"}
                    label="Coupon starts with a string:"
                    required
                    style={{
                      transform: "translateX(15px)",
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Enter a valid string",
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) => {
                        setCheckMultipeCoupon(false);
                      }}
                      style={{
                        width: "254px",
                      }}
                      className="formInput"
                    />
                  </Form.Item>
                  {couponAvailable && checkMultipeCoupon && (
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        transform: "translateX(15px)",
                      }}
                    >
                      <CloseCircleFilled style={{ color: "red" }} />
                      <span>Not Available,Try another name</span>
                    </div>
                  )}
                  {!couponAvailable && checkMultipeCoupon && (
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        transform: "translateX(15px)",
                      }}
                    >
                      <CheckCircleFilled
                        style={{ color: "rgba(65, 159, 35, 1)" }}
                      />
                      <span>Available</span>
                    </div>
                  )}{" "}
                  <div
                    style={{
                      display: "flex",
                      transform: "translateX(15px)",
                      marginBottom: "10px",
                      marginTop: "15px",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontWeight: "500", marginRight: "5px" }}>
                      Super-Code URL:
                    </span>{" "}
                    <span
                      style={{
                        color: "rgba(0, 145, 234, 1)",
                        textDecoration: "underline",
                        fontWeight: "400",
                        fontSize: "15px",
                      }}
                    >
                      {window.location.origin}/register/?referral=
                      {multipeCouponString}
                    </span>
                    <CopyOutlined
                      data-openpopup={"no"}
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          `${window.location.origin}/register/?referral=${multipeCouponString}`
                        );
                        success("Super Code Copied");
                      }}
                      style={{
                        color: "rgb(0, 145, 234)",
                        cursor: "pointer",
                        transform: "scale(1.1)",
                        marginLeft: "10px",
                      }}
                    />
                  </div>
                  <Button
                    onClick={(e) => {
                      form.submit();
                    }}
                    loading={loadCreateCoupon}
                    disabled={loadCreateCoupon}
                    style={{
                      transform: "translateX(15px)",
                      left: "-230px",
                    }}
                    className="createCouponsButton"
                  >
                    Create Coupons
                  </Button>
                </div>
              )}
            </div>
          </div>
          {/* <TableFilter globalSearch={globalSearchFunction} />
        <Table
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => {
                setEditCouponData(record);
                setOpenEditCoupon(true);
              },
            };
          }}
          loading={couponsTableLoading}
          rowClassName="td"
          columns={couponColumns}
          dataSource={filteredCouponsData}
        ></Table> */}
        </Form>
      </div>
      <div className="firstContainer">
        <SuperCodesTable
          tableLoading={tableLoading}
          tableData={tableData}
          formateSuperCodeTableData={formateSuperCodeTableData}
          setTableData={setTableData}
        />
      </div>
    </div>
  );
};

export default SuperCodes;
